module.exports = __webpack_public_path__ + "static/media/codePost_scholarship_image.e8416b39.jpg";